// Dòng "Phí đào tạo Master Class" — và "Bồi thường khiếu nại" (QĐ 0384), cùng
// bước trừ góp — trên phiếu lương (QĐ 0298, màn mẫu CEO duyệt
// 05/10/2026): tên khoản, kỳ thứ mấy, còn lại bao nhiêu — để không ai thắc mắc
// vì sao lương hụt. Dùng chung cho "Lương của tôi", "Chi tiết lương" và bản in.
import type { PayrollRecord } from "../lib";
import { vnd } from "../constants";
import {
  installmentLabel,
  trainingFeeAuditHint,
  trainingFeeHint,
  trainingFeeTag,
  trainingFeesOf,
} from "../trainingFee";

type Props = {
  record: PayrollRecord;
  /** "audit": lời giải thích cho người soát lương (ngày báo, tổng, đã trừ). */
  variant?: "mine" | "audit";
  /** Ô chữ hẹp hơn ở bảng chi tiết lương. */
  dense?: boolean;
};

export function TrainingFeeRows({ record, variant = "mine", dense = false }: Props) {
  const pad = dense ? "px-1 py-1.5 md:px-2" : "px-2 py-1.5";
  return (
    <>
      {trainingFeesOf(record).map((item) => (
        <tr key={item.receivableId} data-testid="training-fee-row" className="bg-warning-bg">
          <td className={pad}>
            <span className="mr-2">{installmentLabel(item)}</span>
            <span className="inline-block whitespace-nowrap rounded-full border border-warning px-2 text-xs font-semibold text-warning-text">
              {trainingFeeTag(item)}
            </span>
            <span className="mt-0.5 block text-xs text-muted-foreground">
              {variant === "audit" ? trainingFeeAuditHint(item) : trainingFeeHint(item)}
            </span>
          </td>
          <td className={`${pad} whitespace-nowrap text-right align-top tabular-nums`}>
            − {vnd(item.amount)}
          </td>
        </tr>
      ))}
    </>
  );
}
